module.exports = __webpack_public_path__ + "img/tokenNoValido.e8031bbd.svg";